import log from "@/common/log";
import axios from "axios"

const taxApiStatus = {
    canceled: false,
    lastResult: null
};

const taxRequestAbortController = new AbortController();
const deskPhoneTaxRequestAbortController = new AbortController();

window.taxApiStatus = taxApiStatus;

const fetchEstimateTax = (data) => {
    if(taxApiStatus.canceled) return Promise.reject('estimate api is locked.');
    return axios.post('/opc/tax/estimate', data, {
        signal: taxRequestAbortController.signal
    }).then(res => {
        taxApiStatus.lastResult = res;
        return res;
    });
};

export function lockAndCancelTaxApi() {
    taxRequestAbortController.abort();
    deskPhoneTaxRequestAbortController.abort();
    taxApiStatus.canceled = true;
}

export const estimateTax = (data) => {
    return fetchEstimateTax(data).catch((err) => {
        log('error', err)
        return Promise.resolve(taxApiStatus.lastResult)
    });
};

const fetchDeskPhoneTax = (data) => {
    if(taxApiStatus.canceled) return Promise.reject('desk phone estimate api is locked.');
    return axios.post('/billing/ecomm/seller/tax/estimate', data, {
        signal: deskPhoneTaxRequestAbortController.signal
    }).then(res => {
        taxApiStatus.lastResult = res;
        return res;
    });
};

export const estimateDeskPhoneTax = (data) => {
    return fetchDeskPhoneTax(data).catch((err) => {
        log('error', err)
        return Promise.resolve(taxApiStatus.lastResult)
    });
};

export const getDefaultEcmInfo = (country, state) => axios.get(`/billing/ecomm/seller/certificate?country=${country}&state=${state}`)
